import React, { createContext, useCallback, useContext, useState } from 'react';

interface CopilotContextValue {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

const CopilotContext = createContext<CopilotContextValue | null>(null);

export const CopilotProvider: React.FC = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((prev) => !prev), []);
  return (
    <CopilotContext.Provider value={{ isOpen, open, close, toggle }}>
      {children}
    </CopilotContext.Provider>
  );
};

/**
 * Returns the copilot open/close state.
 * Returns `null` outside of <CopilotProvider> so callers (e.g. nav buttons that
 * may render in non-gated contexts) can no-op gracefully instead of throwing.
 */
export const useCopilotMaybe = (): CopilotContextValue | null => {
  return useContext(CopilotContext);
};
